__turbopack_context__.v({
  "tag": "tag-module-scss-module__fVTTUW__tag",
});
